export default __webpack_public_path__ + "static/media/team_one.d7ba76e6.jpg";